import * as React from "react";
import classnames from "classnames";
import { getSelectionBoxStyles } from "@grandvisionhq/elements";
import { useLink } from "@grandvisionhq/frk-routing";
import { getProductKeyFromCTType } from "@grandvisionhq/utils";
/* empty css               */
const FacetLink = ({
  item,
  isActive,
  className,
  children,
  onPick,
  productType,
  accessibleName
}) => {
  const productLink = useLink({
    route: "products.detail",
    params: {
      slug: item.slug,
      sku: item.sku,
      key: getProductKeyFromCTType(productType)
    }
  });
  const queryString = typeof window !== "undefined" ? window.location.search : "";
  const href = `${productLink?.href}${queryString}`;
  const { name, facetTerm, sku } = item;
  const selectionBoxClassnames = getSelectionBoxStyles({
    isSelected: isActive,
    isDisabled: false,
    className
  });
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      href,
      "data-t": "facet-picker-link",
      key: item.sku,
      title: accessibleName,
      className: `facet-link ${classnames(selectionBoxClassnames)}`,
      onClick: (event) => onPick({ event, sku, href, name, facetTerm })
    },
    children
  );
};
export {
  FacetLink
};
//# sourceMappingURL=FacetLink.js.map
